export default {
  Dicrect: 0, // thực chi ~ tạm ứng sang thực chi
  Advance: 1, // tạm ứng
  AdvancePay: 2, // Ứng trước đủ đk thanh toán
  AdvanceUnPay: 3, // Ứng trước chưa đủ đk thanh toán) ~
  AdvanceToDicrect: 4, //tạm ứng sang thực chi
  AdvanceToSpent: 9, // ứng trước chưa đủ đktt sang ứng trước đủ đktt
  AdvanceRecovery: 6, //thu hồi tạm ứng
  PayAdvancePayment: 5, //Nộp trả - Tạm ứng
  PayDicrect: 11, //Nộp trả - Thực chi
  Restore: 8, //khôi phục
  NoCashWithDraw: 7, // Không tích nghiệp vụ nào
};
